import { IOGCRepository, OGCFileEntity, OGCFileFormatEnum, ResponseValueObject } from '@gishub/domain';

export class OGCRepository implements IOGCRepository {
  async getSupportedFormats(): Promise<ResponseValueObject<OGCFileEntity[]>> {
    return new ResponseValueObject(true, [
      { format: OGCFileFormatEnum.Shapefile, label: 'Shapefile (.zip)', accept: '.zip' },
      { format: OGCFileFormatEnum.GeoJSON, label: 'GeoJSON', accept: '.geojson,.json' },
      { format: OGCFileFormatEnum.KML, label: 'KML', accept: '.kml' },
    ]);
  }
}
